import React from 'react';
import { DateTime } from 'luxon';
import { CalendarHeader } from './Calendar.styles';
import styled from 'styled-components';
import { CalendarMonthYearControls } from './CalendarMonthYearControls';
import { IHasTestData } from '../../test-utilities/IHasTestData';
import { Button } from '../Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faAngleLeft } from '@fortawesome/pro-solid-svg-icons';
export interface ICalendarControlsProps extends IHasTestData {
  displayDate: { year: number; month: number };
  monthControlType: 'label' | 'control';
  onCalendarChange: (value: { year: number; month: number }) => void;
  showExtraMonths?: 'both' | 'next' | 'previous';
  yearControlType: 'label' | 'control';
}

const StyledIcon = styled(FontAwesomeIcon)`
  color: ${(props) => props.theme.colors.black};
  width: 24px;
`;

export const StyledButton = styled(Button)`
  box-shadow: 0px 0px 0px ${(props) => props.theme.colors.white};
  :hover {
    height: 24px;
    width: 24px;
    border-radius: 50%;
    background-color: ${(props) => props.theme.colors.gray200};
    color: ${(props) => props.theme.colors.defaultContentText};
    box-shadow: 0px 0px 0px ${(props) => props.theme.colors.white};
  }
`;

export const CalendarControls: React.FC<ICalendarControlsProps> = ({
  displayDate,
  monthControlType,
  onCalendarChange,
  showExtraMonths,
  yearControlType,
  'data-test-id': dataTestId,
  'data-test-class': dataTestClass,
}) => (
  <CalendarHeader showExtraMonths={showExtraMonths}>
    <StyledButton
      intent={'ghost'}
      isInline
      onClick={() => {
        const { month, year } = DateTime.local(displayDate.year, displayDate.month).minus({ months: 1 });
        onCalendarChange({ month, year });
      }}
      type="button"
      data-test-class={dataTestClass}
      data-test-id={dataTestId}
    >
      <StyledIcon icon={faAngleLeft} size={'lg'} />
    </StyledButton>
    {(showExtraMonths === 'both' || showExtraMonths === 'previous') && (
      <CalendarMonthYearControls
        displayDate={DateTime.local(displayDate.year, displayDate.month).minus({ months: 1 })}
        monthControlType={'label'}
        onCalendarChange={() => void 0}
        yearControlType={'label'}
        data-test-class={dataTestClass}
        data-test-id={dataTestId}
      />
    )}
    <CalendarMonthYearControls
      displayDate={displayDate}
      monthControlType={monthControlType}
      onCalendarChange={onCalendarChange}
      yearControlType={yearControlType}
      data-test-class={dataTestClass}
      data-test-id={dataTestId}
    />
    {(showExtraMonths === 'both' || showExtraMonths === 'next') && (
      <CalendarMonthYearControls
        displayDate={DateTime.local(displayDate.year, displayDate.month).plus({ months: 1 })}
        monthControlType={'label'}
        onCalendarChange={() => void 0}
        yearControlType={'label'}
        data-test-class={dataTestClass}
        data-test-id={dataTestId}
      />
    )}
    <StyledButton
      intent={'ghost'}
      isInline
      onClick={() => {
        const { month, year } = DateTime.local(displayDate.year, displayDate.month).plus({ months: 1 });
        onCalendarChange({ month, year });
      }}
      type="button"
      data-test-class={dataTestClass}
      data-test-id={dataTestId}
    >
      <StyledIcon icon={faAngleRight} size={'lg'} />
    </StyledButton>
  </CalendarHeader>
);
